module.exports = __webpack_public_path__ + "assets/img/ic-other-card.b8e499ae.svg";